import { Component, OnDestroy } from '@angular/core';
import { ListColumnComponent, ListRowComponent, ListViewComponent, ListViewDirective } from 'components/layout/list-view/list-view.component';
import { CredentialType } from 'enums/CredentialType';
import { HubAction } from 'enums/HubAction';
import { MessageType } from 'enums/MessageType';
import { AccountingPlanSetupModel } from 'models/generated/Entities.Accounting.AccountingPlanSetup';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { AccountingService } from 'services/accounting.service';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl } from 'services/navigation.service';
import { PushService } from 'services/push.service';
import { AccountingPlanSetupComponent } from './accounting-plan-setup.component';

@Component({
	selector: 'list-accounting-plan-setups',
	templateUrl: './list-accounting-plan-setups.component.html',
	imports: [Layout, ListViewComponent, ListViewDirective, ListRowComponent, ListColumnComponent, AccountingPlanSetupComponent, TranslatePipe]
})
@CredentialRequired(CredentialType.AccountingPlanSetupAccessFull)
@ComponentUrl('accounting-plan-setups')
export class ListAccountingPlanSetupsComponent implements OnDestroy {

	changeSubscription?: Subscription;
	accountingPlanSetups?: AccountingPlanSetupModel[];
	selectedAccountingPlanSetup?: AccountingPlanSetupModel;

	constructor(private readonly accountingService: AccountingService, private readonly pushService: PushService) {
		this.getAccountingPlanSetups();

		this.changeSubscription = this.pushService.onChanges<{ accountingPlanSetupId: string }>(MessageType.AccountingPlanSetupChanges).subscribe((event) => {
			if (this.selectedAccountingPlanSetup && event.action == HubAction.Delete && event.data?.accountingPlanSetupId == this.selectedAccountingPlanSetup.id) {
				this.selectedAccountingPlanSetup = undefined;
			}
			this.getAccountingPlanSetups();
		});
	}

	createNewAccountingPlanSetup() {
		this.selectedAccountingPlanSetup = new AccountingPlanSetupModel();
	}

	getAccountingPlanSetups() {
		this.accountingService.getAccountingPlanSetups(true).then((setups) => {
			this.accountingPlanSetups = setups.sort((a, b) => a.name.localeCompare(b.name));
		})
	}

	ngOnDestroy(): void {
		if (this.changeSubscription) this.changeSubscription.unsubscribe();
	}
}
